export const enum UserStatus {
  'REGISTERED' = 1,
  'VERIFICATED' = 2,
  'AUTHORIZED_IN_BOT' = 3,
}
